import type { RegionLabelFragment } from "../client/generated";
import { useOverlayScale } from "../editor/hooks";
import { CSS_IN_TO_PX } from "../editor/utils";
import { getRegionType, getRegionName } from "../types/utils";
import { cn } from "@acdc2/ui/lib/utils";
import { useId } from "react";

type Props = {
  fragment: RegionLabelFragment;
};

export function RegionLabel({ fragment }: Props) {
  const overlayScale = useOverlayScale();
  const filterId = useId();

  const pageWidth = fragment.page.width * CSS_IN_TO_PX;
  const pageHeight = fragment.page.height * CSS_IN_TO_PX;
  const regionType = getRegionType(fragment);

  const mostTopLeftPoint = [...fragment.shape.vertices].sort((a, b) => {
    return a.top - b.top || a.left - b.left;
  })[0];

  return (
    <>
      <defs>
        <filter x="0" y="0" width="1" height="1" id={filterId}>
          <feFlood
            className={cn({
              "flood-color-region-untyped-mid": regionType === "untyped",
              "flood-color-region-hybrid-mid": regionType === "hybrid",
              "flood-color-region-heading-mid": regionType === "heading",
              "flood-color-region-caption-mid": regionType === "caption",
              "flood-color-region-formula-mid": regionType === "formula",
              "flood-color-region-figure-mid": regionType === "figure",
              "flood-color-region-image-mid": regionType === "image",
              "flood-color-region-list-mid":
                regionType === "list" ||
                regionType === "listItem" ||
                regionType === "sublist",
              "flood-color-region-artifact-mid": regionType === "artifact",
              "flood-color-region-table-mid": regionType === "table",
              "flood-color-region-toc-mid": regionType === "toc",
              "flood-color-region-text-mid": regionType === "text",
            })}
          />
          <feComposite in="SourceGraphic" operator="over" />
        </filter>
      </defs>
      <text
        dx={mostTopLeftPoint.left * pageWidth - 1 / overlayScale}
        dy={mostTopLeftPoint.top * pageHeight - 4 / overlayScale}
        fontSize={14 / overlayScale}
        filter={`url(#${filterId})`}
        className="fill-white"
      >
        {getRegionName(fragment)}
      </text>
    </>
  );
}
